module.exports = __webpack_public_path__ + "static/media/help-rule-5c.6d533de8.gif";